import {Action, Dispatch} from 'redux';
import {API} from '../../../utils/API';
import {guessTimezone} from '../../../utils/time-zone-formatter';

import {
  SIGNIN_START,
  SIGNIN_SUCCESS,
  SIGNIN_FAIL,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
} from './constants';

export type ProviderName = 'facebook' | 'google' | 'pramp';

export interface IAuthAction extends Action {
  errors?: any;
  response?: any;
  provider?: ProviderName;
}

export const signInStart = (provider: ProviderName = 'pramp') => ({type: SIGNIN_START, provider});
export const signInSuccess = (response) => ({type: SIGNIN_SUCCESS, response});
export const signInFail = (data) => ({type: SIGNIN_FAIL, errors: data.response.errors});

export const forgotPasswordStart = () => ({type: FORGOT_PASSWORD_START});
export const forgotPasswordSuccess = (response) => ({type: FORGOT_PASSWORD_SUCCESS, response});
export const forgotPasswordFail = (data) => ({type: FORGOT_PASSWORD_FAIL, errors: data.response.errors});

export const userLogin = data => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      dispatch(signInStart(data.provider && data.provider.name));
      const res = await API.postJSON('/user/login', {...data, timezone: guessTimezone()});
      dispatch(signInSuccess(res));

      if (res.redirectUrl) {
        window.location.href = res.redirectUrl;
      }
    } catch (err) {
      dispatch(signInFail(err));
    }
  };
};

export const userForgotPassword = (email: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      dispatch(forgotPasswordStart());
      const res = await API.postJSON('/user/forgotpassword', {email});
      dispatch(forgotPasswordSuccess(res));
    } catch (err) {
      dispatch(forgotPasswordFail(err));
    }
  };
};
